import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16b3c46d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "redLine pa-0 ma-0" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_auto_resize_text = _resolveDirective("auto-resize-text")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "pb-3" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "2",
                class: "pl-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12 pa-0 ma-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    flat: "",
                    class: "country-name-vcard",
                    "max-width": "100%"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "10" }, {
                            default: _withCtx(() => [
                              _withDirectives((_openBlock(), _createBlock(_component_v_card_title, { class: "countryNameText pa-0 ma-0" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.countryName), 1)
                                ]),
                                _: 1
                              })), [
                                [_directive_auto_resize_text]
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                icon: "",
                                onClick: _ctx.closeModal,
                                variant: "text",
                                class: "crossButton iconButton_light"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    class: "crossIcon",
                                    flat: "",
                                    ripple: false
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-close")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}